export interface MealServingTimeOption {
  label: string;
  mealType: string;
  servingTime: string;
  hour: number;
}

export const MEAL_SERVING_TIME_OPTIONS: MealServingTimeOption[] = [
  {
    label: "Breakfast",
    mealType: "breakfast",
    servingTime: "06:00:00",
    hour: 6,
  },
  { label: "Lunch", mealType: "lunch", servingTime: "12:00:00", hour: 12 },
  { label: "Dinner", mealType: "dinner", servingTime: "17:00:00", hour: 17 },
];

export const getMealLabelByServingTime = (servingTime: string): string =>
  MEAL_SERVING_TIME_OPTIONS.find((option) => option.servingTime === servingTime)
    ?.label ?? "";
